var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.191,
    height: 80.156,
    viewBox: "0 0 101.191 80.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34353",
    "data-name": "Group 34353",
    transform: "translate(1.873 2.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M4330.569,2942.334h-8.908v-8.908h-8.781v8.908h-8.909v8.782h8.909v8.908h8.781v-8.908h8.908Z",
    transform: "translate(-4280.326 -2891.028)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29775",
    "data-name": "Group 29775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29774",
    "data-name": "Group 29774"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 91.334,
    transform: "translate(3.055 76.134)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29772",
    "data-name": "Group 29772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M4295.159,2890.616c-2.4,5.126,2.668,10.622,9.4,10.622h0c4.839,0,9.188-4.786,9.8-8.7",
    transform: "translate(-4275.51 -2869.133)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M4283.747,2846.641l-10.881,27.419c-1.32,2.821-4.641,4.686-8.347,4.686h0c-7.046,0-11.318-6.338-7.539-11.184l11.821-19.321a4.156,4.156,0,0,1,3.278-1.6",
    transform: "translate(-4255.571 -2846.641)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M4338.115,2846.641l-2.945,23.045c-.75,4.807,3.847,9.06,9.793,9.06h0c5.947,0,10.544-4.253,9.794-9.06l-2.945-23.045",
    transform: "translate(-4296.242 -2846.641)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29773",
    "data-name": "Group 29773",
    transform: "translate(16.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M4394.711,2890.616c2.4,5.126-2.668,10.622-9.4,10.622h0c-4.838,0-9.187-4.786-9.8-8.7",
    transform: "translate(-4333.424 -2869.133)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M4342.122,2846.641,4353,2874.061c1.32,2.821,4.641,4.686,8.346,4.686h0c7.047,0,11.318-6.338,7.539-11.184l-11.82-19.321a4.159,4.159,0,0,0-3.279-1.6h-64.429",
    transform: "translate(-4289.361 -2846.641)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    y2: 36.337,
    transform: "translate(64.901 39.589)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 36.337,
    transform: "translate(8.382 39.589)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y2: 36.337,
    transform: "translate(88.92 39.589)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y2: 2.06,
    transform: "translate(72.953 55.697)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.db77327ede108096d538f47686ac79b0.svg";
export { ForwardRef as ReactComponent };